import { linkify } from '@utils/directives';

export default ({ app }) => {
  app.use(linkify);
};
